import { useMutation } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";

export const UnAssignTransactionContext = createContext(null);

type Props = {
  children: ReactElement;
};

const UnAssignTransactionProvider: FunctionComponent<Props> = ({
  children,
}) => {
  const { mutateAsync, data, isPending, error } = useMutation({
    mutationFn: async (payload: any) => {
      const data = await Api.post(
        `tm/transactions/${payload.user_id}/assignment`,
        payload,
      );
      return data;
    },
    onError: (err) => {
      console.log(err, "###");
    },
  });

  const contextValue = useMemo(
    () => ({
      mutateAsync,
      data,
      error,
      isPending,
    }),
    [mutateAsync, data, error, isPending],
  );
  return (
    <UnAssignTransactionContext.Provider value={contextValue}>
      {children}
    </UnAssignTransactionContext.Provider>
  );
};

export default UnAssignTransactionProvider;
